import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/img/icon/plane-fill-darkblue.svg'
import _imports_1 from '@/assets/img/icon/bus-fill-darkblue.svg'


const _hoisted_1 = { class: "grid grid-cols-3 md:grid-cols-6" }
const _hoisted_2 = { class: "col-span-2 md:col-span-5" }
const _hoisted_3 = { class: "font-bold text-2xl" }
const _hoisted_4 = {
  key: 0,
  class: "color-blue-grey-darken-1 font-semibold mb-2"
}
const _hoisted_5 = { class: "flex gap-4" }
const _hoisted_6 = { class: "flex items-center gap-2" }
const _hoisted_7 = {
  key: 0,
  class: "flex items center background-custom-light-blue-1 border-custom-dark-blue-1 rounded px-12px py-4px text-xs"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "mr-3 w-4",
  alt: "edit"
}, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "color-grey-5" }, /*#__PURE__*/_toDisplayString('Rute Bandara'), -1)
const _hoisted_10 = [
  _hoisted_8,
  _hoisted_9
]
const _hoisted_11 = {
  key: 1,
  class: "flex items center background-custom-light-blue-1 border-custom-dark-blue-1 rounded px-12px py-4px text-xs"
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  class: "mr-3 w-4",
  alt: "edit"
}, null, -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", { class: "color-grey-5" }, /*#__PURE__*/_toDisplayString('Rute Bus'), -1)
const _hoisted_14 = [
  _hoisted_12,
  _hoisted_13
]
const _hoisted_15 = {
  class: "background-grey-2 rounded px-12px py-4px text-xs color-blue-grey-darken-1",
  style: {"border":"1px solid #607D8B"}
}
const _hoisted_16 = { class: "border-none md:border-solid border-l border-neutral-400 flex flex-col" }
const _hoisted_17 = { class: "flex m-auto gap-4" }
const _hoisted_18 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputSwitch = _resolveComponent("InputSwitch")!
  const _component_Card = _resolveComponent("Card")!
  const _component_HjpDataList = _resolveComponent("HjpDataList")!
  const _component_ListActions = _resolveComponent("ListActions")!
  const _component_OverlayPanel = _resolveComponent("OverlayPanel")!
  const _component_HjpCofirmModal = _resolveComponent("HjpCofirmModal")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_HjpDataList, {
      endpoint: _ctx.params.endpoint,
      isOpenNewPage: _ctx.params.isOpenNewPage,
      baseRoute: _ctx.params.baseRoute,
      buttonTitle: _ctx.params.buttonTitle,
      headerTitle: _ctx.params.headerTitle,
      fieldSearch: ['name', 'terminal']
    }, {
      content: _withCtx(({ dataItems }) => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dataItems, (item, idx) => {
          return (_openBlock(), _createBlock(_component_Card, {
            class: "card-item mb-4 wrap-card-route",
            key: idx
          }, {
            content: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                  _createElementVNode("p", _hoisted_3, _toDisplayString(item?.Name), 1),
                  (item.Terminal.length > 0)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(`${item.Terminal[0].Name} - ${item.Terminal[item.Terminal.length - 1].Name}`), 1))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, [
                      (item.MsRouteTypeId === 1)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_7, _hoisted_10))
                        : (_openBlock(), _createElementBlock("div", _hoisted_11, _hoisted_14))
                    ]),
                    _createElementVNode("div", _hoisted_15, _toDisplayString(`${item.Terminal.length} Terminal`), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("div", _hoisted_17, [
                    _createVNode(_component_InputSwitch, {
                      class: "input-success",
                      modelValue: item.IsActive,
                      "onUpdate:modelValue": ($event: any) => ((item.IsActive) = $event),
                      onChange: ($event: any) => (_ctx.onChangeActivate(item))
                    }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"]),
                    _createElementVNode("i", {
                      class: "pi pi-ellipsis-h text-base cursor-pointer color-dark",
                      onClick: ($event: any) => (_ctx.showDropDown($event, item))
                    }, null, 8, _hoisted_18)
                  ])
                ])
              ])
            ]),
            _: 2
          }, 1024))
        }), 128))
      ]),
      _: 1
    }, 8, ["endpoint", "isOpenNewPage", "baseRoute", "buttonTitle", "headerTitle"]),
    _createVNode(_component_OverlayPanel, { ref: "op" }, {
      default: _withCtx(() => [
        _createVNode(_component_ListActions, {
          edit: true,
          del: true,
          editTitle: "Edit Rute",
          delTitle: "Hapus Rute",
          onDel: _ctx.onDelete,
          onEdit: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onEdit(_ctx.dataRow.Id)))
        }, null, 8, ["onDel"])
      ]),
      _: 1
    }, 512),
    _createVNode(_component_HjpCofirmModal, {
      show: _ctx.modalConfirmation.show,
      title: _ctx.modalConfirmation.title,
      subTitle: _ctx.modalConfirmation.subTitle,
      btnSubmitTitle: _ctx.modalConfirmation.btnSubmitTitle,
      onOnSubmit: _ctx.doSubmit,
      onHideDialog: _ctx.hideConfirmModal
    }, null, 8, ["show", "title", "subTitle", "btnSubmitTitle", "onOnSubmit", "onHideDialog"])
  ]))
}